import React, { Component } from "react";
import { reduxForm } from "redux-form";
import { push } from "react-router-redux";
import Input from "../../../../components/form/Input";
import Button from "../../../../components/form/Button";
import Select from "../../../../components/form/Select";
import DatePicker from "../../../../components/form/DateTime";
import { ReduxCheckbox as Checkbox } from "../../../../components/form/Checkbox";
import CroField from "../generalForm/CroField";
import CroTiptapEditor from "../generalForm/CroTiptapEditor";
import { styles } from "../../index";
import { asyncForm } from "../../../../utils/asyncForm";
import * as V from "../../../../utils/formValidation";
import askAction from "../AskAction";

import { DocumentTemplatesType } from "../../enum";

class DocumentTemplateForm extends Component {
  render() {
    const {
      error,
      onSubmit,
      handleSubmit,
      onDelete,
      submitting,
      askAction,
      isNew,
      templateKeys,
    } = this.props;

    return (
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="cro-form long-label templateForm"
      >
        <div className="templateForm__section">
          <CroField
            title="Typ šablony"
            name="type"
            component={Select}
            items={DocumentTemplatesType}
            disabled={!isNew}
            fullWidth
            validate={[V.required]}
          />
        </div>

        <div className="templateForm__section">
          <div className="templateForm__grid">
            <CroField
              className="third"
              title="Platnost od"
              name="validFrom"
              component={DatePicker}
              disabled={!isNew}
              noIcon
              fullWidth
              validate={[V.required]}
            />
            <CroField
              className="third"
              title="Platnost do"
              name="validTo"
              component={DatePicker}
              noIcon
              fullWidth
            />
            {!isNew && (<CroField
              className="third"
              title="Verze"
              name="version"
              component={Input}
              fullWidth
              disabled
            />)}
            {!isNew && (<CroField
              className="third"
              title="Publikováno"
              name="published"
              component={Checkbox}
              fullWidth
              disabled
            />)}
          </div>
        </div>

        <div className="templateForm__section templateForm__contentWrapper">
          <CroTiptapEditor
            title="Obsah dokumentu"
            name="content"
            fullWidth
            rows={40}
            validate={[V.required]}
          />
        </div>

        {templateKeys && templateKeys.length > 0 && (
            <div className="templateForm__templateKeys">
              <div className="hint">V obsahu šablony můžete využít placeholdery, které se při generování nahradí konkrétními hodnotami. K dispozici jsou placeholdery:</div>
              <ul>
                {templateKeys.map((key) => (
                    <li key={key.name}><b>{key.name}</b> = {key.description}</li>
                ))}
              </ul>
            </div>
        )}

        <div className="templateForm__footer">
            <div className="templateForm__footerInner">
              {error && <div className="error">{error}</div>}
              {!this.props.valid && this.props.submitFailed && !error && (
                <div className="error">
                  Povinná pole nejsou správně vyplněna.
                </div>
              )}
              <div className="templateForm__hint">
                Povinná pole jsou označena hvězdičkou.
              </div>

              <div className="templateForm__actions">
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Zpět"
                  disabled={submitting}
                  onClick={() =>
                    this.props.dispatch(push(`/administrator/sablony/dokument`))
                  }
                />
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Uložit"
                  disabled={submitting}
                  onClick={handleSubmit(onSubmit)}
                />
                {!isNew && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Smazat"
                    disabled={submitting}
                    onClick={askAction(
                      onDelete,
                      "Opravdu chcete smazat tuto šablonu?",
                    )}
                  />
                )}
              </div>
            </div>
          </div>
      </form>
    );
  }
}

export default reduxForm({
  form: "documentTemplateForm",
})(askAction(asyncForm(DocumentTemplateForm)));
